import React, { useState } from 'react';
import { BottomActionBarV2, AritoFormV2, DialogV2, AritoIcon } from '@/components/custom/erp';
import { CoQuanThueFormattedData, SearchFormValues, searchSchema } from '../../schema';
import CoQuanThueForm from './CoQuanThueForm';
import { CoQuanThue } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface CoQuanThueDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: SearchFormValues;
  onClose: () => void;
  onSubmit?: (data: CoQuanThueFormattedData) => void;
  selectedObj?: CoQuanThue | null;
  updateCoQuanThue?: (uuid: string, data: CoQuanThueFormattedData) => Promise<void>;
  addCoQuanThue?: (data: CoQuanThueFormattedData) => Promise<void>;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}
const CoQuanThueDialog = ({
  open,
  mode,
  initialData,
  onClose,
  onSubmit,
  selectedObj,
  updateCoQuanThue,
  addCoQuanThue,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: CoQuanThueDialogProps) => {
  const handleSubmit = async (data: SearchFormValues) => {
    const formattedData: CoQuanThueFormattedData = {
      ma_cqt: data.ma_cqt,
      ten_cqt: data.ten_cqt,
      ma_cqt0: data.ma_cqt0 || null,
      status: data.trang_thai.toString()
    };

    try {
      if (mode === 'edit' && selectedObj && updateCoQuanThue) {
        await updateCoQuanThue(selectedObj.uuid, formattedData);
      }
      if (mode === 'add' && addCoQuanThue) {
        await addCoQuanThue(formattedData);
      } else if (onSubmit) {
        onSubmit(formattedData);
      }

      onClose();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };
  const title = mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem';

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={title}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={12} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={searchSchema}
          onSubmit={handleSubmit}
          initialData={initialData}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<CoQuanThueForm mode={mode} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default CoQuanThueDialog;
